import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue';
import { SwiperManager } from '.';


export default /*#__PURE__*/_defineComponent({
  __name: 'ManagedSwiper',
  props: {
    swiperManager: null,
    swiperStyle: null,
    swiperWrapperStyle: null,
    swiperSlideStyle: null
  },
  emits: ['mouseover', 'mouseleave'],
  setup(__props: any, { emit }) {

const props = __props as {
    swiperManager: SwiperManager<any>,
    swiperStyle?: string,
    swiperWrapperStyle?: string,
    swiperSlideStyle?: string,
}





const swiperEl = ref<HTMLElement | undefined>();

const handleMouseOver = () => {
    emit('mouseover');
    props.swiperManager.reportMouseOver();
};

onMounted(() => {
    props.swiperManager.setSwiperElement(swiperEl.value as HTMLElement);
});

return { __sfc: true,emit, props, swiperEl, handleMouseOver }
}

})